import { gql } from '@apollo/client';
const SET_WORKING_SEASON = gql `
  mutation SetWorkingSeason($seasonId: ID!) {
    setWorkingSeason(seasonId: $seasonId) {
      season {
        id
        name
        workingSeason
        canNameBeUpdated
        canBeRemoved
      }
    }
  }
`;
export default SET_WORKING_SEASON;
